export default "__VITE_PUBLIC_ASSET__741d3aed__"